import d from"../src/navigation-bar/navigation-bar.scss.js";import"./game-navigation/product-category-list/product-category-list.js";import"./game-navigation/product-category-drawer/product-category-drawer.js";import"./trade-navigation/trade-categories-list/trade-categories-list.js";import"./trade-navigation/trade-category-drawer/trade-category-drawer.js";import"./profile/profile-drawer/profile-drawer.js";import"./profile/profile-dropdown/profile-dropdown.js";import"./cart-icon/cart-icon.js";import"./notifications/notifications-drawer/notifications-drawer.js";import"./notifications/notifications-dropdown/notifications-dropdown.js";import"../button/button.js";import"../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i,nothing as h}from"../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{customElement as b}from"../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/custom-element.js";import{property as a}from"../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/property.js";import{ChicksGroupElement as m}from"../base/ChicksGroupElement.js";import{when as o}from"../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/directives/when.js";import{unsafeCSS as g}from"../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/css-tag.js";var w=Object.defineProperty,y=Object.getOwnPropertyDescriptor,e=(u,r,c,n)=>{for(var s=n>1?void 0:n?y(r,c):r,l=u.length-1,p;l>=0;l--)(p=u[l])&&(s=(n?p(r,c,s):p(s))||s);return n&&s&&w(r,c,s),s};let t=class extends m{constructor(){super(...arguments),this.layoutVariant="large",this.showDivider=!0,this.logo="https://placehold.co/224x64",this.currency="USD",this.language="EN",this.showSwap=!1,this.cartQuantity=0,this.cartLabel="Cart",this.notificationsCount=0,this.notifications=[],this.notificationsLabel="Notifications",this.admin=!1,this.username="ChicksGold User"}get startSlotTemplate(){return i`
            ${o(this.layoutVariant!=="large",()=>this.website==="CX"?i`
                    <cds-navigation-bar-trade-category-drawer
                        base-url="${this.baseUrl}"
                        website="${this.website}"
                        currency="${this.currency}"
                        language="${this.language}"
                    ></cds-navigation-bar-trade-category-drawer>
                `:i`
                    <cds-navigation-bar-product-category-drawer
                        currency="${this.currency}"
                        language="${this.language}"
                        base-url="${this.baseUrl}"
                        website="${this.website}"
                        show-swap="${this.showSwap}"
                    ></cds-navigation-bar-product-category-drawer>
                `)}
            <img src="${this.logo}" alt="${this.website} logo" loading="lazy">
        `}get mainSlotContent(){return this.layoutVariant!=="large"?h:this.website==="CX"?i`
                <cds-navigation-bar-trade-categories-list
                    base-url="${this.baseUrl}"
                    website="${this.website}"
                ></cds-navigation-bar-trade-categories-list>
            `:i`
            <cds-navigation-bar-product-category-list
                base-url="${this.baseUrl}"
                show-swap="${this.showSwap}"
                website="${this.website}"
            ></cds-navigation-bar-product-category-list>
        `}get endSlotContent(){return this.layoutVariant!=="large"?i`
                ${o(this.username&&this.website!=="CX"&&this.cartQuantity,()=>i`
                        <cds-navigation-cart-icon
                            quantity="${this.cartQuantity}"
                            label="${this.cartLabel}"
                            small="${this.layoutVariant!=="large"}"
                            @click="${()=>this.dispatchEvent(new CustomEvent("cartclicked",{bubbles:!0,composed:!0}))}"
                        ></cds-navigation-cart-icon>
                    `)}
                ${o(this.username,()=>i`
                        <cds-navigation-bar-notifications-drawer
                            website="${this.website}"
                            label="${this.notificationsLabel}"
                            base-url="${this.baseUrl}"
                            count="${this.notificationsCount}"
                            .notifications="${this.notifications}"
                        ></cds-navigation-bar-notifications-drawer>
                        <cds-profile-drawer
                            website="${this.website}"
                            admin="${this.admin}"
                            selected-option="${this.selectedProfileOption}"
                        ></cds-profile-drawer>
                    `,()=>i`
                        <cds-button
                            button-icon="person"
                            @click="${()=>this.dispatchEvent(new CustomEvent("loginclicked",{bubbles:!0,composed:!0}))}"
                        >
                            Sign In
                        </cds-button>
                    `)}
            `:i`
            ${o(this.username&&this.website!=="CX"&&this.cartQuantity,()=>i`
                    <cds-navigation-cart-icon
                        quantity="${this.cartQuantity}"
                        label="${this.cartLabel}"
                        @click="${()=>this.dispatchEvent(new CustomEvent("cartclicked",{bubbles:!0,composed:!0}))}"
                    ></cds-navigation-cart-icon>
                `)}
            ${o(this.username,()=>i`
                    <cds-navigation-bar-notifications-dropdown
                        y-offset="4"
                        website="${this.website}"
                        label="${this.notificationsLabel}"
                        base-url="${this.baseUrl}"
                        count="${this.notificationsCount}"
                        .notifications="${this.notifications}"
                    ></cds-navigation-bar-notifications-dropdown>
                    <cds-profile-dropdown
                        y-offset="4"
                        username="${this.username}"
                        website="${this.website}"
                        admin="${this.admin}"
                        selected-option="${this.selectedProfileOption}"
                    ></cds-profile-dropdown>
                `,()=>i`
                    <cds-button
                        button-icon="person"
                        @click="${()=>this.dispatchEvent(new CustomEvent("loginclicked",{bubbles:!0,composed:!0}))}"
                    >
                        Sign In
                    </cds-button>
                `)}
        `}render(){return i`
            <div class="cds-navigation">
                <slot name="start">${this.startSlotTemplate}</slot>
                ${this.showDivider&&this.layoutVariant==="large"?i`<div class="logo-divider"></div>`:""}
                <div class="main-nav">
                    <slot>${this.mainSlotContent}</slot>
                    <div class="end-area">
                        <slot name="end">${this.endSlotContent}</slot>
                    </div>
                </div>
            </div>
        `}};t.styles=[g(d)];e([a({attribute:"layout-variant"})],t.prototype,"layoutVariant",2);e([a({type:Boolean,attribute:"show-divider"})],t.prototype,"showDivider",2);e([a()],t.prototype,"logo",2);e([a()],t.prototype,"currency",2);e([a()],t.prototype,"language",2);e([a({attribute:"show-swap",type:Boolean})],t.prototype,"showSwap",2);e([a({attribute:"cart-quantity",type:Number})],t.prototype,"cartQuantity",2);e([a({attribute:"cart-label"})],t.prototype,"cartLabel",2);e([a({attribute:"notifications-count",type:Number})],t.prototype,"notificationsCount",2);e([a({type:Array})],t.prototype,"notifications",2);e([a({attribute:"notifications-label"})],t.prototype,"notificationsLabel",2);e([a({type:Boolean})],t.prototype,"admin",2);e([a({attribute:"selected-profile-option"})],t.prototype,"selectedProfileOption",2);e([a()],t.prototype,"username",2);t=e([b("cds-navigation-bar")],t);export{t as CdsNavigationBar};
